export interface ITestplanBasicData {
    id: string;
    name: string;
    description: string;
    codeId: string;
    isEnabled: boolean;
}

export class TestplanBasicData implements ITestplanBasicData {
    id: string;
    name: string;
    description: string;
    codeId: string;
    isEnabled: boolean;

    constructor(id: string, name: string, description: string, codeId: string, isEnabled: boolean) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.codeId = codeId;
        this.isEnabled = isEnabled;
    }
}

const defaultTestplanBasicData = new TestplanBasicData("", "", "", "", false);
export { defaultTestplanBasicData }